import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Col, Container, Row, Spinner } from 'reactstrap';
import { AutobizButton, AutobizIcon, AutobizSectionTitle } from 'autobiz-strap';
import { t } from 'autobiz-translate';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Header from '../Header/Header';
import { getUserSelector } from '../../view-models-generators/userSelector';
import 'react-phone-number-input/style.css';
import AuthSpinner from '../AuthSpinner/AuthSpinner';
import Profile from './Profile';
import UserAlcopa from './UserAlcopa';
import { userAlcopaCredentialSelector } from '../../view-models-generators/userAlcopaCredentialSelector';

const UserProfile: React.FC = () => {
    const navigate = useNavigate();
    const { user, updateStatus, status } = useSelector(getUserSelector);
    const { isAlcopaActive, alcopaStatus } = useSelector(userAlcopaCredentialSelector);

    // const remove AZ
    const canAccessUserProfilePage = ['STLA'].includes(user.provider);
    const canAccessUserAlcopa =
        ['AZ'].includes(user.provider) && user.roles.includes('buyerCarcheck') && isAlcopaActive;

    if (updateStatus === 'succeeded') {
        window.location.reload();
    }

    const handleGoDashboard = () => {
        navigate('/dashboard');
    };

    if ([status, alcopaStatus].includes('loading')) return <Spinner />;

    if (canAccessUserProfilePage === false && canAccessUserAlcopa === false) {
        return (
            <>
                <Header />
                <Container className="hasFixedHeader">
                    <Row className="my-5 sticky-preferences-ctas justify-content-center text-center">
                        <Col xs="12" md="6" className="mb-2">
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: t('messageProfilePageNotAuthorized') || '',
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col xs="6" md="3">
                            <AutobizButton
                                type="submit"
                                color="primary"
                                block
                                onClick={handleGoDashboard}
                            >
                                {t('ctaDashboard')}
                            </AutobizButton>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }

    return (
        <>
            <Header />
            <Container className="hasFixedHeader">
                <Row>
                    <Col>
                        <div className="mt-4">
                            <AutobizSectionTitle>
                                <AutobizIcon name="User" /> {t('profilePageTitle')}
                            </AutobizSectionTitle>
                            {canAccessUserProfilePage && <Profile />}
                            {canAccessUserAlcopa && <UserAlcopa />}
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default withAuthenticationRequired(UserProfile, {
    returnTo: '/userprofile',
    onRedirecting: () => <AuthSpinner />,
});
